import ReactDOM from 'react-dom'; 
import React , { useState } from 'react';
import CryptoJS from 'crypto-js';
import { elementsStyle, elementsClass } from "./utility";
import config from '../config';

const ivString = '\0'.repeat(16); // 16 null characters

export const elementBackground = function(value, type, overlayColor) {
    if(value) {
      if(value !== "") {  
        if(overlayColor){
          // console.log("overlayColor ccc", overlayColor)
          const rgba = app.getColor(overlayColor);
          const overlayValue = `linear-gradient(${rgba}, ${rgba})`;
          if(type === "color") {
            // console.log("${overlayValue}, linear-gradient(${value}, ${value})", overlayValue, value)
            value = app.getColor(value);
            return `${overlayValue}, linear-gradient(${value}, ${value})`;
          }
          else if(type === "l_gradient") {
            return `${overlayValue}, linear-gradient(to bottom right, ${app.getColor(value.split("$$")[0])}, ${app.getColor(value.split("$$")[1])}) `;
          }
          else if(type === "pattern") {
            return `${overlayValue}, url(${app.cdn(value)}) repeat center / 20px 20px`;
          }
          return `${overlayValue}, url("${app.cdn(value)}") no-repeat center / cover`;
        }
        else{
          if(type === "color") {
            value = app.getColor(value);
            return `${value}`;
          }
          else if(type === "l_gradient") {
            return `linear-gradient(to bottom right, ${app.getColor(value.split("$$")[0])}, ${app.getColor(value.split("$$")[1])}) `;
          }
          else if(type === "pattern") {
            return `url(${app.cdn(value)}) repeat center / 20px 20px`;
          }else{
            return `url("${app.cdn(value)}") no-repeat center / cover`;
          } 
        }
       
      }
    }
    return "";
  }

export const elementPadding = function(padding) {  
    if (padding) {
        const values = padding.split(','); // Split the padding string into an array 
        return values.map((value) => `${value}px`).join(' '); // Convert and join the values
    } 
}

export const isButton = function(data, device) {  
  if (data) {
    if(device === "desktop"){
      if(data.properties.showWeb){
        return `btn-showWeb`
      }else{
        return `btn-hideWeb`
      }
    }else{
      if(data.properties.show){
        return `btn-showMob`
      }else{
        return `btn-hideMob`
      }
    } 
  } 
  return ''
}

export const isHideAll = function(data, device) {  
  if (data && data.elements) { 
      let shouldReturnTrue = false;
      let hasTrue = false;
      
      for (var k in data.elements) { 
          if (data.elements[k].viewType !== "grid") {
              if (data.elements[k]["properties"]) {
                if(device === "desktop"){
                  if (data.elements[k]["properties"].showWeb === true) {
                    hasTrue = true;
                  }
                  if (data.elements[k]["properties"].showWeb !== true) {
                      shouldReturnTrue = true;
                  } 
                }else{
                  if (data.elements[k]["properties"].show === true) {
                    hasTrue = true;
                  }
                  if (data.elements[k]["properties"].show !== true) {
                      shouldReturnTrue = true;
                  } 
                }
                  
              }
          }

          if (data.elements[k]["items"]) {  
              data.elements[k]["items"].forEach(function(val) {
                  for (var key in val) {
                      if (key !== "viewType" && key !== "gridId" && key !== "viewId") {
                        if(device === "desktop"){
                          if (val[key]["properties"] && val[key]["properties"].showWeb === true) {
                            hasTrue = true;
                          }
                          if (val[key]["properties"] && val[key]["properties"].showWeb !== true) {
                              shouldReturnTrue = true;
                          } 
                        }else{
                          if (val[key]["properties"] && val[key]["properties"].show === true) {
                            hasTrue = true;
                          }
                          if (val[key]["properties"] && val[key]["properties"].show !== true) {
                              shouldReturnTrue = true;
                          } 
                        } 
                      } 
                  } 
              }); 
          }  
      }

      if (shouldReturnTrue && !hasTrue) {
          return true;
      }  
  }
  return false;
}



const app = {
    getStyle:function(data, device) {
        const style = {};
        if(!data) {
          return style;
        }
        if(elementsStyle[data.viewType]) {
          elementsStyle[data.viewType].forEach(function(v){
            const value = data.properties[v.value];
            
            if(v.key === "fontFamily") {
              style[v.key] = value;  
            } 
            else if(v.key === "fontSize") {
              if(v.value === "iconSizeWeb") {
                if(device === "desktop") {
                  if(data.properties["iconSizeWeb"] !== null){
                    style[v.key] = data.properties["iconSizeWeb"] + 'px';
                  } 
                }
                else {
                  if(data.properties["iconSize"] !== null){
                    style[v.key] = data.properties["iconSize"] + 'px';
                  } 
                }
              }else{
                if(device === "desktop") {
                  if(data.properties["textSizeWeb"] !== null){
                    style[v.key] = data.properties["textSizeWeb"] + 'px'; 
                  }  
                }
                else {
                  if(data.properties["textSize"] !== null){
                    style[v.key] = data.properties["textSize"] + 'px';
                  } 
                }
              } 
            }
            else if(v.key === "color") {
              if(device === "desktop" && data.properties["iconColorWeb"] !== undefined){
                style[v.key] = app.getColor(data.properties["iconColorWeb"]);
              }else{
                style[v.key] = app.getColor(value);
              } 
            } 
            else if(v.key === "padding") { 
              if(device === "desktop") { 
                style[v.key] = elementPadding(data.properties["paddingWeb"]);
              }
              else {
                style[v.key] = elementPadding(data.properties["padding"]);
              }
            }

            else if(v.key === "margin") { 
              if(device === "desktop") { 
                style[v.key] = elementPadding(data.properties["marginWeb"]);
              }
              else {
                style[v.key] = elementPadding(data.properties["margin"]);
              }
            }
 

            else if(v.key === "background") {
               if(device === "desktop" && data.properties["backgroundWeb"] !== undefined){
                if(data.properties.backgroundWeb) {
                  if(data.properties.overlayColorWeb && data.properties.overlayColorWeb !== ""){
                    style[v.key] = elementBackground(data.properties.backgroundWeb, data.properties.backgroundWebType, data.properties.overlayColorWeb);
                  }else{
                    style[v.key] = elementBackground(data.properties.backgroundWeb, data.properties.backgroundWebType);
                  }  
                }
              }else{
                if(v.value === "iconBackground") { 
                  if(value) { 
                    if(device === "desktop" && data.properties["iconBackgroundWeb"] !== undefined){
                      style["background"] = app.getColor(data.properties.iconBackgroundWeb); 
                    }
                    else{
                      style[v.key] = app.getColor(value);
                    } 
                  }
                }
                else { 
                  if(value) {
                    if(data.properties.overlayColor && data.properties.overlayColor !== ""){
                      style[v.key] = elementBackground(value, data.properties.backgroundType, data.properties.overlayColor);
                    }else{
                      style[v.key] = elementBackground(value, data.properties.backgroundType);
                    } 
                  }
                }
              }
              
            }

            
            else if(v.key === "borderBottom") {
              let type = data.properties["dividerType"];
              if(type === 'line'){
                type = "solid"
              }else if(type === 'dash'){
                type = "dashed"
              }
              if(data.properties["enableDivider"]){
                style[v.key] = value+'px '+type+' '+app.getColor(data.properties["dividerColor"]); 
              }
              
            } 
            else if(v.key === "border") {
              let type = data.properties["borderType"];
              if(type === 'line'){
                type = "solid"
              }else if(type === 'dash'){
                type = "dashed"
              }
              if(data.properties["borderColor"]){
                style[v.key] = value+'px '+type+' '+app.getColor(data.properties["borderColor"]); 
              } 
            }
            else if(v.key === "buttonBorder") { 
              if(data.properties["borderColor"]){
                style["border"] = '1px solid '+app.getColor(data.properties["borderColor"]); 
              } 
            }
            else if(v.key === "borderRadius") {
              style[v.key] = elementPadding(data.properties["borderCorners"]);
              style['overflow'] = 'overflow-hidden'; 
            }
            
            else if(v.key === "borderWidget") { 
              let type = data.properties["borderType"];
              if(type === 'line'){
                type = "solid"
              }else if(type === 'dash'){
                type = "dashed"
              }
              if(data.properties["borderColor"]){ 
                style['borderWidth'] = value !== undefined ? elementPadding(value) : 0; 
                style['borderStyle'] = type; 
                style['borderColor'] = app.getColor(data.properties["borderColor"]); 
              } 
            }

            else if(v.key === "logoDimension") {  
              if(data.properties["logoDimension"]){ 
                style['width'] = value+'px';   
              } 
            }

            else if(v.key === "boxShadow") {   
              if(data.properties.fixedPosition && data.properties.dropShadow){  
                style['boxShadow'] = `0px ${data.properties.dropShadowDistance}px ${data.properties.dropShadowBlur}px  ${data.properties.dropShadowSpread}px ${app.getColor(data.properties.dropShadowColor)}`;   
              } 
            } 

          })
        }
        return style;
      },
      getClass:function(data, device) {
        if(!data) {
          return "";
        }
        const style = [data.viewType];
        if(elementsClass[data.viewType]) { 
          elementsClass[data.viewType].forEach(function(v){ 
            const value = data.properties[v]; 
            let settingsValue = '';
            if(data.settings){
              settingsValue = data.settings[v];
            }

            if(v === "showWeb") { 
              if(value === false) { 
                style.push("desktop-d-none")
              }
            }
            if(v === "show") { 
              if(value === false) {
                style.push("mobile-d-none")
              }
            } 

            if(v === "fixedPosition" && app.getDevice()) {  
              if(value === true) {
                style.push("position-fixed");
                style.push("header-fixed")
              }
            } 

            if(v === "textAlignment") {
              if(value === "start") {
                style.push("text-start")
              }
              if(value === "center") {
                style.push("text-center")
              }
              if(value === "end") {
                style.push("text-end")
              }
              if(value === "justify") {
                style.push("text-justify")
              }
            }
            if(v === "itemAlignment") {
              if(value === "start") {
                style.push("text-start")
              }
              if(value === "center") {
                style.push("text-center")
              }
              if(value === "end") {
                style.push("text-end")
              }
              if(value === "justify") {
                style.push("text-justify")
              }
            }   
            
            if(!app.getDevice()){  // As per Tester he want show all change for Mobile so I add info icon and hide funcanility
                if(v === "isBlurImage"){ 
                  // if(settingsValue === true) { 
                  //   style.push("isBlurImage")
                  // }
                }
              // if(v === "isText"){ 
              //   if(settingsValue === false) { 
              //     style.push("isText")
              //   }
              // }
              if(v === "hideHeader"){ 
                // if(settingsValue === true) { 
                //   style.push("hideHeader")
                // }
              }
              
            }
            

          })
        }
        return style.join(" ");
      },
      fetchPost:async function(data, mode) {
          if(!mode) {
          //  app.preloader(true);
          }
          let response = await fetch(app.config().aiPostURL, {
            body:JSON.stringify({
                payload:app.encrypt2(JSON.stringify(data))
            }),
            //body:JSON.stringify(data),
            method: "POST",
            headers:{
              'Content-Type': 'application/json'
            }
          });
          response = await response.json();
          response = JSON.parse(app.decrypt2(response.data));
          if(!mode) {
           // app.preloader(false);
          }
          return response;
      },
      isButton:isButton,
      isHideAll:isHideAll,
      elementPadding:elementPadding,
      elementBackground:elementBackground,
      cdn:function(text) {
        if(text) {
          return text.replaceAll("__CDN__PATH__", `${app.config().bucket}/`);
        }
        return text;
      }, 
      config:function() {
        return config
      },
      getColor:function(argb){
        if(argb) {
          if(argb.length === 7) {
            return argb;
          }
          else {
            return argb.replace(argb.substr(1, 2), "") + argb.substr(1, 2);
          } 
        }
        return ""; 
      },
      getBorder:function(properties){
        let type = properties["borderType"];
        if(type === 'line'){
          type = "solid"
        }else if(type === 'dash'){
          type = "dashed"
        }
        if(properties["borderColor"]){
          return properties.borderSize+'px '+type+' '+app.getColor(properties["borderColor"]); 
        } 
        else {
          return "";
        }
      },
     
      getDevice:function() {
        const isWIndow =  typeof window === "undefined"
        if(!isWIndow){
          if(localStorage.getItem("device") === "mobile") {
            return false;
          }
        } 
        return  true;
     },
      loadScript: function (jqueryFile, id, type) {
        return new Promise(function (resolve, reject) {
          var jqueryScript = document.createElement("script");
          jqueryScript.src = jqueryFile;
          jqueryScript.async = true;
          if (id) {
            jqueryScript.id = id;
          }
          jqueryScript.onerror = function () {
            reject();
          };
          jqueryScript.onload = function () {
            resolve(jqueryScript);
          };
          if (type) {
            document.body.appendChild(jqueryScript);
          } else {
            document.head.appendChild(jqueryScript);
          }
        });
      },
      modal: function (params) {
        let style = {
          background: "rgba(255,255,255,.95",
          title: "#000000",
          text: "#333333",
          buttonBackground: "rgba(255,255,255,.95",
          button: "#007aff",
        };
        var bgColor = style.background;
        var titleColor = style.title;
        var textColor = style.text;
        var buttonBgColor = style.buttonBackground;
        var buttonColor = style.button;
    
        params = params || {};
        var buttonsHTML = "";
        if (params.buttons && params.buttons.length > 0) {
          for (var i = 0; i < params.buttons.length; i++) {
            buttonsHTML +=
              '<span class="modal-button' +
              (params.buttons[i].bold ? " modal-button-bold" : "") +
              '" style="color:' +
              buttonColor +
              "; background-color:" +
              buttonBgColor +
              '">' +
              params.buttons[i].text +
              "</span>";
          }
        }
        var titleHTML = params.title
          ? '<div class="modal-title" style="color:' +
            titleColor +
            '">' +
            params.title +
            "</div>"
          : "";
        var textHTML = params.text
          ? '<div class="modal-text" style="color:' +
            textColor +
            '">' +
            params.text +
            "</div>"
          : "";
        var afterTextHTML = params.afterText ? params.afterText : "";
        var noButtons =
          !params.buttons || params.buttons.length === 0 ? "modal-no-buttons" : "";
        var verticalButtons = params.verticalButtons
          ? "modal-buttons-vertical"
          : "";
        var modalButtonsHTML =
          params.buttons && params.buttons.length > 0
            ? '<div class="modal-buttons modal-buttons-' +
              params.buttons.length +
              " " +
              verticalButtons +
              '" >' +
              buttonsHTML +
              "</div>"
            : "";
        var modalHTML =
          '<div class="modal ' +
          noButtons +
          " " +
          (params.cssClass || "") +
          '" ><div class="modal-dialog modal-dialog-scrollable modal-xl" style="background-color:' +
          bgColor +
          '">' +
          (titleHTML + textHTML + afterTextHTML) +
          "</div>" +
          modalButtonsHTML +
          "</div>";
    
        window.$("body").append(
          '<div class="modal-overlay modal-overlay-visible"></div>' + modalHTML
        );
        var modal = window.$(".model");
    
        modal
          .addClass("d-block")
          .show()
          .css({
            marginTop: -Math.round(modal.outerHeight() / 2) + "px",
          });
    
        // Add events on buttons
    
        modal.find(".modal-button").each(function (index, el) {
          window.$(el).on("click", function (e) {
            if (
              params.buttons[index] === undefined ||
              params.buttons[index] === "undefined"
            ) {
              modal.remove();
              window.$(".modal-overlay").remove();
            } else {
              if (params.buttons[index].close !== false) app.closeModal(modal);
              if (params.buttons[index].onClick)
                params.buttons[index].onClick(modal, e);
              if (params.onClick) params.onClick(modal, index);
            }
          });
        });
        return modal;
      }, 
      model: function (title, text, url) {
        let isVisible = true; 
        const remove = () => {
          document.querySelector('.shareWrapper').remove()
        };
        const buttons = [
            {
                text: app.getLang("facebook")?app.getLang("facebook"):'Facebook',
                link: "http://www.facebook.com/sharer.php?u=" + url
            },
            {
                text: app.getLang("twitter")?app.getLang("twitter"):'Twitter',
                link: "https://twitter.com/share?url=" + url + "&amp;text=" + title
            },
            {
                text: app.getLang("email")?app.getLang("email"):'Email',
                link: "mailto:?&subject=" + title + "&body=" + text + "%0D%0A" + url
            },
            {
                text: app.getLang("linkedin")?app.getLang("linkedin"):'Linkedin',
                link: "https://www.linkedin.com/sharing/share-offsite/?url=" + url
            }
        ];
     
          return <div className="modal shareWrapper" style={{ display: "block" }}>
                <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered h-auto" style={{maxWidth: "280px", margin:"0px auto"}}>
                    <div className="modal-content text-center">
                        <div className="modal-header py-3">
                          <h6 className="text-center fw-bold w-100 m-0">{app.getLang("shareContent")?app.getLang("shareContent"):'Share Content'}</h6>
                         </div>
    
                        <div className="modal-body p-0">
                            <div className="list-group list-group-flush share-list" style={{fontSize: '15px',fontFamily: "-apple-system,SF UI Text,Helvetica Neue,Helvetica,Arial,sans-serif", color:"#007aff"}}>
                                {buttons.map((v, i) => (
                                    <a key={`key-${i}`} className="list-group-item" target='_blank' href={v.link}>
                                        {v.text}
                                    </a>
                                ))}
                              <a className="list-group-item" onClick={()=>remove()}>{app.getLang("cancel")?app.getLang("cancel"):'Cancel'}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
      }, 
      shareContent: function (title, text, url) {
        const div = document.createElement("div");
        document.body.appendChild(div);
        ReactDOM.render(app.model(title, text, url), div); 
      },
      isMobile:function() {
        const isWIndow =  typeof window === "undefined"
          if(!isWIndow){
            var isMobile = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent) || /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
              if (isMobile) {
                  return "is-mobile";
              } 
          }  
          return ''; 
      }, 
      getLang:function(key) {
        let lang = {};
        const isWIndow = typeof window === "undefined"; 
        if(!isWIndow){
          if(localStorage.getItem("aiConfig")) {
            lang = JSON.parse(localStorage.getItem("aiConfig"));
            return lang.languageSettings[key];
          } 
        }   
       return ''
      }, 
      getMode:function(mode) {
        return (mode === "live" || mode === "preview");
      },  
      checkLocalHost:function(){
        const host = window.location.hostname;
        if(["72snappy.pbodev.info", "localhost"].indexOf(host) !== -1) {
            return true;
        }
        return false;
      },
      aiGenerated:function(mode, src){
        const isServer = typeof window === "undefined";
        if(!isServer) {
          if(localStorage.getItem("aiGenerated")) {
            if(mode === "preview" && src.indexOf("/generated/") !== -1) {
              return true;
            }
          }
        }
        return false;
      },
  aiBackground:function(mode, src){
    const isServer = typeof window === "undefined";
    if(!isServer) {
      if(localStorage.getItem("aiBackground") && src.indexOf("/generated/") !== -1) {
        if(mode === "preview") {
          return true;
        }
      }
    }
    return false;
  },
  aiBanner:function(mode){
    const isServer = typeof window === "undefined";
    if(!isServer) {
      if(localStorage.getItem("aiBanner")) {
        if(mode === "preview") {
          return true;
        }
      }
    }
    return false;
  },
  iconsFilter:function(pages, type){
    const data = {
      cart:["ecommerce", "dinein", "foodcourt", "foodordering", "hyperstore", "digitalstore"],
      location:["auction", "dating", "datingrevamp", "dinein", "event", "foodcourt", "hyperlocal", "loyaltycard", "loyalty","services", "taxi-ride", "demanddelivery"],
      notification:["notification"]
    }
    let mode = "";
    if(type === "cart") {
      mode = "cart-no";
      pages.forEach(function(v){
        if(data[type].indexOf(v.pageIdentifier) !== -1) {
          mode = "cart-yes";
        }
        if(data[type].indexOf(v.pageid) !== -1) {
          mode = "cart-yes";
        }
      })
    }
    if(type === "location") {
      mode = "location-no";
      pages.forEach(function(v){
        if(data[type].indexOf(v.pageIdentifier) !== -1) {
          mode = "location-yes";
        }
        if(data[type].indexOf(v.pageid) !== -1) {
          mode = "location-yes";
        }
      })
    }
    if(type === "notification") {
      mode = "notification-yes";
      // mode = "notification-no";
      // pages.forEach(function(v){
      //   if(data[type].indexOf(v.pageIdentifier) !== -1) {
      //     mode = "notification-yes";
      //   }
      //   if(data[type].indexOf(v.pageid) !== -1) {
      //     mode = "notification-yes";
      //   }
      // })
    }
    return mode;
  },
  getHide:function(data) {
    let style = [];
    if(data.properties) {
      if(data.properties.showWeb === false) {
        style.push("desktop-d-none");
      }
      if(data.properties.showWeb === false) {
        style.push("mobile-d-none");
      }
    }
    return style.join(" ");
  },
  encrypt2: (data) => {
    const key = CryptoJS.enc.Utf8.parse(config.keyString);
    const iv = CryptoJS.enc.Utf8.parse(ivString);
    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString(); // Return the full encrypted string
  },
  decrypt2:  (encryptedData) => {
    try {
      const key = CryptoJS.enc.Utf8.parse(config.keyString);
      const iv = CryptoJS.enc.Utf8.parse(ivString);
  
      const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
  
      //console.log("Decrypted Bytes:", decrypted); // Debug: Check decrypted bytes
  
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  
      if (!decryptedText) {
        throw new Error('Decryption failed. The output is empty.');
      }
  
      return decryptedText;
    } catch (error) {
      console.error("Decryption error:", error.message);
      return null;
    }
  },
  isWebsiteBuilder:function(){
    const isServer = typeof window === "undefined";
    if(!isServer) {
      if(window.location.pathname === "/website/creator-software/build"){
        return true;
      }
    }
    return false; 
  },
  isHeaderFooter:function(){
    const isServer = typeof window === "undefined";
    if(!isServer) {
      if(localStorage.getItem("aiPageId")) {
        if(localStorage.getItem("aiPageId").indexOf('header_') !== -1){
          return "is_header";
        } 
        if(localStorage.getItem("aiPageId").indexOf('footer_') !== -1){
          return "is_footer";
        } 
      }
    }
    return ""; 
  },
  getDom:function() {
    const isServer = typeof window === "undefined";
    if(!isServer) {
      if(document.querySelector("#iframe")) {
        return document.querySelector("#iframe").contentWindow.document;
      }
      return document;
    }
    return null;
  } 
}

export default app